module.exports = __webpack_public_path__ + "39e692c7a919acd1598bfbea576cb152.svg";